import AppRoute from "models/AppRoute"
import { Guid } from "@/types"

interface IOfferEditRouteParams {
    offerId: Guid
}

interface IOfferEditRouteQuery {
    backUrl?: string
}

const OfferEditRoute = new AppRoute<IOfferEditRouteParams, IOfferEditRouteQuery>({
    route: "/offers/:offerId/edit",
    navbar: true,
    authRequired: true,
})

export default OfferEditRoute
